import styled from "styled-components/macro";

export const TabLabel = styled.span`
  position: relative;
  display: inline-flex;
  align-items: flex-start;

  ${({ color }) =>
    color != null
      ? `
      padding-right: 14px;
          &::after {
            content: "";
            position: absolute;
            top: 2px;
            right: 0;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: ${color};
            box-shadow: 0 0 0 1px white;
          }
        `
      : ""}
`;
